import React from 'react';

import { useMatch } from 'react-router-dom';

import { StyledLink } from 'components/app-header/styled';

interface INavLink {
  matchRoute?: string;
  [key: string]: any;
}

const NavLink: React.FC<INavLink> = ({ matchRoute, ...props }) => {
  const routeToMatch = matchRoute || props.to;
  const match = useMatch(routeToMatch);
  return <StyledLink className={match ? 'selected' : ''} {...props} />;
};

export default NavLink;
